import api from "../service/solicitarDocumento.service";
import * as types from "./solicitarDocumento.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import solicitarDocumentoActions from "./solicitarDocumento.actions";
import solicitarDocumentoSelector from "./solicitarDocumento.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.VERIFICA_DOCUMENTO_LIBERADO_SOLICITACAO, verificaDocumentoLiberadoSolicitacao);
  yield takeEvery(types.PESQUISAR_SOLICITACAO_DOCUMENTO_MODAL, pesquisarSolicitacaoDocumentoModal);
  yield takeEvery(types.ABRIR_SOLICITACAO_DOCUMENTO, abrirSolicitacaoDocumento);
  yield takeEvery(types.VALIDA_GRID_SOLICITAR_DOCUMENTO, validaGridSolicitarDocumento);
  yield takeEvery(types.REMOVE_GRID_SOLICITAR_DOCUMENTO, removeGridSolicitarDocumento);
  yield takeEvery(types.PESQUISAR_SOLICITACAO_DOCUMENTO, pesquisarSolicitacaoDocumento);
  yield takeEvery(types.POST_SOLICITACAO_DOCUMENTO, postSolicitacaoDocumento);
}

function* verificaDocumentoLiberadoSolicitacao() {
  try {
    yield call(api.verificaDocumentoLiberadoSolicitacao);
  }
  catch {
    yield put(formActions.redirect('RedeSIM'));
  }
}

function* pesquisarSolicitacaoDocumentoModal(action) {
  const { payload } = action;
  const state = yield select(solicitarDocumentoSelector.solicitarDocumento);

  try {
    if (state?.tokenRecaptchaModal != "" && state?.tokenRecaptchaModal != undefined) {
      const result = yield call(api.pesquisarSolicitacaoDocumentoCpfCnpj, payload, {
        headers: { tokenRecaptcha: state?.tokenRecaptchaModal }
      });

      yield put(solicitarDocumentoActions.toggleModalPesquisaDocumento());
      if (result.data.length > 1) {
        yield put(solicitarDocumentoActions.setPesquisaDocumento(result.data));
        yield put(formActions.gridReload());
      } else {
        const documento = result.data[0];
        yield setHeaderDocumento(documento);
        yield put(solicitarDocumentoActions.setSolicitacaoDocumentoPost(documento));
        yield put(solicitarDocumentoActions.setPesquisaDocumento([]));
      }
    } else {
      _alert.warning("É necessário validar o ReCaptcha.");
      yield resetRecaptchaModal();
    }
  }
  catch {
    yield resetRecaptchaModal();
    yield put(formActions.redirect('redeSIM.solicitarDocumento'));
    yield put(solicitarDocumentoActions.toggleModalPesquisaDocumento());
  }
}

function* resetRecaptchaModal() {
  const state = yield select(solicitarDocumentoSelector.solicitarDocumento);
  if (state?.recaptchaResetRefModal)
    state.recaptchaResetRefModal.call();
}

function* abrirSolicitacaoDocumento(action) {
  const { payload } = action;

  yield setHeaderDocumento(payload);
  yield put(solicitarDocumentoActions.setSolicitacaoDocumentoPost(payload));
  yield put(solicitarDocumentoActions.setPesquisaDocumento([]));
}

function* validaGridSolicitarDocumento(action) {
  const { payload } = action;

  yield put(solicitarDocumentoActions.setSuggestionDocumento({}));

  if (payload?.SuggestionSolicitarDocumento?.Id == null) {
    _alert.warning('Você precisa selecionar um documento!');
    return;
  }

  const documento = {
    IdTipoDocumento: payload?.SuggestionSolicitarDocumento?.Id,
    TipoDocumento: payload?.SuggestionSolicitarDocumento?.TipoDocumento,
    IdOrgao: payload?.SuggestionSolicitarDocumento?.IdOrgao,
    Orgao: payload?.SuggestionSolicitarDocumento?.Orgao,
  };

  const state = yield select(solicitarDocumentoSelector.solicitarDocumento);

  let { GridSolicitarDocumento } = state;
  let listaGridDocumentoArray = [...GridSolicitarDocumento];

  let newGridDocumentoArray = listaGridDocumentoArray.length > 0 ?
    listaGridDocumentoArray.filter(x => x.IdTipoDocumento == documento?.IdTipoDocumento) : [];

  if (newGridDocumentoArray.length > 0) {
    _alert.warning('Documento já incluído na solicitação.');
    return;
  }

  yield put(solicitarDocumentoActions.setGridSolicitarDocumento([...state.GridSolicitarDocumento, documento]));

  yield put(formActions.gridReload());
}

function* removeGridSolicitarDocumento(action) {
  const { payload } = action;
  const state = yield select(solicitarDocumentoSelector.solicitarDocumento);

  let { GridSolicitarDocumento } = state;
  let listaGridDocumentoArray = [...GridSolicitarDocumento];

  let newGridDocumentoArray = listaGridDocumentoArray.filter(x => x.IdTipoDocumento != payload.IdTipoDocumento);

  yield put(solicitarDocumentoActions.setGridSolicitarDocumento(newGridDocumentoArray));

  yield put(formActions.gridReload());
}

function* pesquisarSolicitacaoDocumento(action) {
  const { payload } = action;

  try {
    yield put(solicitarDocumentoActions.setHeaderDocumento(payload));

    const state = yield select(solicitarDocumentoSelector.solicitarDocumento);

    if (state?.tokenRecaptcha != "" && state?.tokenRecaptcha != undefined) {
      var result = yield call(api.pesquisarSolicitacaoDocumento, payload, {
        headers: { tokenRecaptcha: state?.tokenRecaptcha }
      });

      if (result.data.length > 1) {
        yield put(solicitarDocumentoActions.setPesquisaDocumento(result.data));
        yield put(formActions.gridReload());
      } else {
        yield setHeaderDocumento(result.data[0]);
        yield put(solicitarDocumentoActions.setSolicitacaoDocumentoPost(result.data[0]));
        yield put(solicitarDocumentoActions.setPesquisaDocumento([]));
      }
    } else {
      _alert.warning("É necessário validar o ReCaptcha.");
      yield put(formActions.redirect('redeSIM.solicitarDocumento'));
    }

  }
  catch {
    yield put(formActions.redirect('redeSIM.solicitarDocumento'));
  }
}

function* postSolicitacaoDocumento(action) {
  const state = yield select(solicitarDocumentoSelector.solicitarDocumento);

  if (state?.SuggestionSolicitarDocumento?.Id != null) {
    const result = yield _alert.confirm(
      'O documento selecionado no campo Documento será desprezado, confirma?',
      'Aviso'
    );
    if (!result)
      return;
  }

  let { GridSolicitarDocumento, SolicitacaoDocumentoPost } = state;

  const data = {
    Protocolo: SolicitacaoDocumentoPost.Protocolo,
    CpfCnpjSolicitante: SolicitacaoDocumentoPost.CpfCnpjSolicitante ?? state.CpfCnpjSolicitante ?? state.HeaderDocumento?.CpfCnpjSolicitante,
    CnpjEmpresa: SolicitacaoDocumentoPost.CnpjEmpresa,
    Ccm: SolicitacaoDocumentoPost.Ccm,
    IdSolicitacao: SolicitacaoDocumentoPost.IdSolicitacao,
    IdEmpresa: SolicitacaoDocumentoPost.IdEmpresa,
    NrCnpj: SolicitacaoDocumentoPost.NrCnpj,
    NomeEmpresa: SolicitacaoDocumentoPost.NomeEmpresa,
    IdAnalise: SolicitacaoDocumentoPost.IdAnalise,
    Documentos: GridSolicitarDocumento,
    EmailEmpresa: SolicitacaoDocumentoPost.EmailEmpresa,
    EmailSolicitante: SolicitacaoDocumentoPost.EmailSolicitante,
  }

  if (GridSolicitarDocumento.length == 0) {
    _alert.warning("É necessário associar ao menos um documento para a solicitação.");
  }
  else {
    try {
      var result = yield call(api.postSolicitacaoDocumento, data);

      yield put(solicitarDocumentoActions.setGridResultadoDocumento(result.data));
      yield put(solicitarDocumentoActions.toggleModalResultadoDocumento());
      yield put(formActions.gridReload());
    }
    catch {
      yield put(solicitarDocumentoActions.setSolicitacaoDocumentoPost([]));
      yield put(solicitarDocumentoActions.setPesquisaDocumento([]));
      yield put(solicitarDocumentoActions.setGridSolicitarDocumento([]));
      yield put(formActions.redirect('redeSIM.solicitarDocumento'));
    }
  }
}

function* setHeaderDocumento(data) {
  const state = yield select(solicitarDocumentoSelector.solicitarDocumento);

  yield put(solicitarDocumentoActions.setHeaderDocumento({
    NumeroProtocolo: data.Protocolo ?? state.HeaderDocumento.NumeroProtocolo,
    CnpjEmpresa: data.NrCnpj ?? state.HeaderDocumento.CnpjEmpresa,
    CpfCnpjSolicitante: data.CpfCnpjSolicitante ?? state.HeaderDocumento.CpfCnpjSolicitante,
    NomePessoa: data.NomePessoa ?? state.HeaderDocumento.NomePessoa,
    NomeEmpresa: data.NomeEmpresa ?? state.HeaderDocumento.NomeEmpresa,
    Ccm: data.Ccm ?? state.HeaderDocumento.Ccm,
  }));
}
